<template>
    <ion-page>
        <SignedInHeader></SignedInHeader>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center v-if="!deals || !deals.length">
                        <ion-card v-if="deals === false && !noAlerts">
                            <Loading :msg="$t('screens.feed.loading-deals')"></Loading>
                        </ion-card>
                        <NoAlerts v-else-if="noAlerts"></NoAlerts>
                        <ion-card v-else>
                            <NoDeals />
                        </ion-card>
                    </ion-col>
                    <ion-col v-else>
                        <DealSummary :deals="deals"/>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
        <ion-footer v-if="$store.state.signedIn && notificationBar">
            <ion-toolbar>
                <ion-title>{{ $t('screens.feed.dont-miss') }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button color="primary" fill="solid" expand="full" @click="enableNotifications">{{ $t('screens.feed.enable-notifications') }}</ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-footer>
    </ion-page>
</template>

<script>
    import DealSummary from '@/components/DealSummary.vue';
    import Loading from '@/components/Loading.vue';
    import NoAlerts from '@/components/NoAlerts.vue';
    import NoDeals from '@/components/NoDeals.vue';
    import SignedInHeader from "@/components/SignedInHeader";
    import axios from 'axios';
    import { notifications } from "@/notifications";

    export default {
        name: 'feed',
        components: {
            DealSummary,
            Loading,
            NoAlerts,
            NoDeals,
            SignedInHeader
        },
        data() {
            return {
                deals: false,
                noAlerts: false,
                notificationBar: false
            };
        },
        methods: {
            loadFeed: async function() {
                this.$logger.debug('state', this.$store.state);
                try {
                    const user = await this.$Amplify.Auth.currentAuthenticatedUser();

                    // TODO would be nice to do this async, but then how do we distinguish the error?
                    axios.get(process.env.VUE_APP_API_FEED_BASE + '/deals',
                        { headers: { Authorization: `Bearer ${user.signInUserSession.getIdToken().getJwtToken()}`}}
                    ).then(response => {
                        this.deals = response.data;
                    }).catch((error) => {
                        this.$logger.error(error.response);
                        if (error.response.data && error.response.data.code == 420 ) {
                            // no alerts setup
                            this.noAlerts = true;
                        }
                        //this.$router.push('/addalert');
                    });
                } catch(err) {
                    this.$logger.error(err);
                    if ( (err.response && err.response.status === 401) || err == 'not authenticated') {
                        this.$logger.debug('unauthorized');
                    }
                    //this.$router.push('/splash');
                }
            },
            enableNotifications: function() {
                this.$AmplifyEventBus.$emit('requestNotifications');
            }
        },
        mounted() {
            if ( notifications.isMessagingSupported() && (Notification.permission === 'denied' || Notification.permission === "default")) {
                this.notificationBar = true;
            }
            this.loadFeed();
        },
    }
</script>

<style scoped>
    ion-content {
        --background: url('~@/assets/bg/bg10.jpg') no-repeat center center / cover;
    }

    >>> ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
        padding: 0;
        margin: .5em;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        padding: 0;
    }

    ion-input {
        margin-left: .5em;
    }

    ion-footer ion-title {
        font-size: .8em;
        color: #666;
        font-weight: normal;
    }
</style>
